import { create } from 'zustand';

export type AudioName =
  | 'landingAudio'
  | 'introAudio'
  | 'middleAudio'
  | 'endAudio';

const ALL_AUDIO = ['landingAudio', 'introAudio', 'middleAudio', 'endAudio'];

export interface MusicStoreType {
  landingAudio: HTMLAudioElement | undefined;
  introAudio: HTMLAudioElement | undefined;
  middleAudio: HTMLAudioElement | undefined;
  endAudio: HTMLAudioElement | undefined;

  setAudio: (name: AudioName, audio: HTMLAudioElement) => void;
  stopOther: (name: AudioName) => void;
  fadeIn: (name: AudioName, duration?: number) => void;
  stopAll: () => void;
  fadeOut: (name: AudioName, duration?: number) => void;
}

export const useMusicStore = create<MusicStoreType>((set, get) => ({
  landingAudio: undefined,
  introAudio: undefined,
  middleAudio: undefined,
  endAudio: undefined,

  setAudio: (name, audio) => set({ [name]: audio }),

  fadeIn: (name /* duration */) => {
    const audio = get()?.[name];
    if (!audio) {
      return;
    }
    if (!audio.paused) {
      get().stopOther(name);
      return;
    }

    get().stopOther(name);

    // audio.currentTime = 0;
    // audio.volume = 0;
    audio.play();
    // fadeInAudio(audio, duration ?? 1500);
  },

  fadeOut: (name /* duration */) => {
    const audio = get()?.[name] ?? undefined;
    // audio && fadeOutAudio(audio, duration ?? 1500);
    audio && audio.pause();
  },

  stopAll: () => {
    ALL_AUDIO.forEach(audioName => {
      const audio = get()?.[audioName as AudioName];
      if (!audio) {
        return;
      } else {
        audio.pause();
        // fadeOutAudio(audio, 1500);
      }
    });
  },

  stopOther: name => {
    const otherAudioNames = ALL_AUDIO.filter(_ => _ !== name);

    otherAudioNames.forEach(n => {
      const audio = get()?.[n as AudioName] ?? undefined;
      if (!audio) {
        return;
      } else {
        audio.pause();
        // fadeOutAudio(audio, 1500);
      }
    });
  },
}));
